module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/005TOC#chapter_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("O")])]), _vm._v("n Saturday morning Rebecca woke from a dream that she had swallowed a diamond. The stone was so large that the doctors were sure that it would kill her. Certainly it was indigestible. On the other hand, someone said, it was a very valuable gem. And it wasn’t like it was lost. They knew exactly where it was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fat lotta good "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" does me,” Rebecca had said, and woke. The dream had been so vivid that she could still feel a lump in her bowels, a sensation that only slowly dissipated. She wondered briefly whether her body was trying to tell her that she had cancer. That was all she needed now, a horrible, lingering death to fit into her schedule.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bedroom was bright; she’d slept even later than usual. Normally by this time Mary Martha would have trooped in two or three times with urgencies real and imagined. Her daughter suffered Rebecca’s weekend sloth, Rebecca knew. She felt bad about it herself. She was constantly making vows "), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("to pop up early and seize the day. But the week just seemed to blast every good intention into rubble. Come Saturday morning, she was the same old featureless heap in the bed.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca roused herself, drew her threadbare terry cloth robe about her, and padded down the hall toward the bathroom, expecting her daughter to bound up at any moment. But there was no sign of Mary Martha. The TV in the living room was silent and her daughter’s bedroom was empty except for the usual unicorn tableau and a scatter of books. Rebecca hurried back up the hall to the kitchen, which was also deserted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mary Martha?” she called, hearing the panic-quaver in her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no answer. She was trying to decide whether to begin screaming right there in the kitchen or to run screaming out into the street when she noticed that the back door was ajar. Rebecca went to the window and looked down into the yard, and there was Mary Martha, sitting on the bottom step in the sunlight, talking with Michael Christopher, who was on his hands and knees pulling up weeds.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("With relief came anger for the scare, but the two of them made such a sweet scene that Rebecca didn’t have the heart to break it up. She could not make out their words from where she stood, but she could hear the clear, eager music of Mary Martha’s chatter and the respectful baritone of Christopher’s replies. The discussion appeared to be lively. Her new tenant had kept a low profile since moving in. If he went out during the day, he went out after she left for work. As far as Rebecca knew, he was down there praying, or drinking, whatever ex-monks did. But he seemed normal enough now in jeans and a T-shirt. His hair was growing in a little, and the escaped-convict stubble he’d sported upon his arrival had given way to ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("a softer fuzz. She noted that he had shaved, revealing a sensual mouth and a determined jaw. His face seemed surprisingly vulnerable without the beard. With the downy blur of the new hair and his awkward neck, he looked like a freshly hatched gosling.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While she was standing there, the phone rang. Probably Bob again, Rebecca thought, and let the machine get it. But it was her mother. Rebecca picked up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Screening, are we?” Phoebe noted, amused. At seventy-two, she had one of those wonderful brisk old-lady voices like rung crystal, and something of the freedom to take the world lightly that Rebecca longed for.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bob proposed last night. I’m expecting some aftershocks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah. Which one is Bob, now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Thai food.” Bob had insisted on taking them—Phoebe, Rebecca, and Mary Martha—out for dinner on the previous Mother’s Day to some place in the Marina. “His girls,” he had called them, at least three times. He had almost broken his back opening doors and pulling out chairs, but the conversation had lagged. The main thing Rebecca could recall from the outing was Mary Martha’s delight in the peanut sauce and Bob’s insistence on a broad view of social evolution into the twenty-first century, which had filled the intellectual void like Styrofoam packing pellets. Phoebe, at the end of the evening, had merely remarked, devastatingly, “He seems nice enough.” From someone as capable of intricate analysis as her mother, Rebecca thought, it amounted to a dismissal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah, of course,” Phoebe said now. “Mr. Megatrends 2000.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It was a debacle, I’m afraid. He made quite a production of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phoebe was briskly unsympathetic. “Well, you could see it coming. I hope you weren’t too hard on him.”")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was as nice as I could possibly be, under the circumstances.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca laughed. “I suppose you think I should have taken him up on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And become Mrs. Megatrends?” her mother asked dryly. “Yes, that’s an appealing prospect.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s reading something else by now, I’m sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t give it another thought, Rebecca. There’s no need to settle for mediocrity.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("“I wasn’t even tempted,” Rebecca declared. But she knew that she had been. Not by Bob as he was, but by Bob as he might have been with just a little tweaking here and there and some mysterious infusion of chemistry. A New and Improved Bob. From such wishful thinking it was one short step to trying to do the tweaking yourself and betting the ranch on the mysterious infusion. She had come soberingly close to a ruinous compromise over these past months. If Bob had not so characteristically blundered with his comic opera proposal; if he had made his offer in private, with a touch of humility and a dignified appeal to the longing for companionship, to the sharing of loads; if he had come on with a little humor and frankness about diminishing prospects and caught her on one of those days when the laundry and shopping hadn’t gotten done and there had been no one to pick up Mary Martha at day care and the car’s transmission was making a funny new noise…Well, who knew? It was easy for Phoebe, who had snagged the love of her life in classic fashion, to counsel holding out for excellence. Phoebe had married Rebecca’s father at nineteen and kept his house for forty-two years in perfectly contented devotion. When John Martin had died of a heart attack on the NJT 5:10 out of Penn Station one night on the ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("way home from his office, some ten years ago, Phoebe had been shattered. She had languished for several years, keeping to herself—rattling around the old place, as she said, drinking too much and doing melancholy watercolors. Then, some five years previously, she had moved to California, ostensibly to be near her daughter. She had bought a small house near Stinson Beach and begun to show a surprising zest for widowhood. She was always bopping off to some Shakespeare Festival or orchid show; she worked part-time at a funky little art gallery in town, and she had a hip, even occasionally edgy, set of new friends, painters and writers and Bolinas secessionists.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sound of Mary Martha’s laughter rose from the backyard. She sounded almost giddy. Rebecca edged over to the coffee machine to get a pot of French roast started.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So how’s the hermit?” Phoebe asked, mercifully changing the subject. Rebecca had told her mother about her new tenant, and, predictably, Phoebe was delighted with the notion of a monk downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He appears to be coming out of his shell a bit. He’s out in the backyard right now doing battle with the weeds. Mary Martha likes him a lot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ask him if he does baptisms.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca laughed. “Why? Are you pregnant?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not me, Sherilou just had a kid. She wants to have some kind of ceremony, a touch of spirituality. Though if you ask me, she’d be better off having some kind of father around. But it’s too late for that, alas.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sherilou was one of Phoebe’s projects, a thirtyish poetess living on food stamps and prone to rants. The two of them spent a lot of time at Phoebe’s kitchen table eating Oreo cookies and dissecting the work of Adrienne Rich.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("“I doubt that Mr. Christopher is doing any freelance sacra")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("mental work,” Rebecca said. “I get the impression he left the monastery on an awkward note.”")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just a few words in the proper spirit is all we’re looking for. A soupçon of ritual. It’s not like Sherilou is looking to renounce Satan and his works or anything. It’s a fragmented culture. We don’t need the whole nine yards.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure the man just wants to be left alone, Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course, of course.” Phoebe paused. Rebecca could picture her mother, spry and lean in charcoal gray Nordstrom slacks and running shoes, her silver hair cut short, looking out her kitchen window at the Pacific Ocean, one foot thumping like a rabbit’s, her mind already on to something else.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sure enough, Phoebe said, “I should get going. We’ve got an opening today and I promised Jack I’d help set up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course. Love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Love you too, darling. Are you going to get up here this weekend?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We can’t; Rory’s got Mary Martha. Theoretically.” Rebecca glanced at the clock. It was almost eleven. Her ex-husband, a professional surfer, kept vampire hours and seldom showed up before noon for his every-other-week bit of fatherly quality time. More often than not, he took Mary Martha straight to Ocean Beach and left her on the sand all day with his current girlfriend and a bag of potato chips while he tried to coax a ride out of the chop. But Mary Martha adored him. “Maybe next weekend?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I suppose that will have to do. Kiss Mary Martha for me and tell her Grandma loves her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And ask the monk about the baptism. I think the fact that’s he’s a renegade will appeal to Sherilou.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s not a renegade, Mom. He’s a sad man having one helluva midlife crisis.”")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All the more reason to get him involved in something meaningful. I’ve really got to run. Kiss-kiss.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Kiss-kiss.” Rebecca smiled as she hung up. The coffee was ready. She poured herself a cup and went to the back window again. Christopher was on his knees again, wrestling with a deeply rooted weed. He had cleared about three square feet of ground by now. The dark earth looked fresh and raw against the burned yellow skin of the rest of the yard. Mary Martha was sitting contentedly on the bottom step in her pajamas, watching him with perfect absorption, offering the occasional comment or advice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On an impulse, Rebecca opened the window.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, there, Don Quixote, how about a cup of coffee before you finish off that windmill?” she called down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Christopher glanced up, startled and even a little alarmed, apparently unprepared for conversation with a grown-up. “Oh! Hello!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good morning. Would you like some coffee?” she repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Coffee?” Christopher echoed, as if the word were new to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca laughed. “Didn’t they have coffee in the monastery?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They had the world’s worst coffee, actually,” Christopher conceded. “Gallons of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I make the world’s best, if I do say so myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wouldn’t want to trouble you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s no trouble at all. It’s already made.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Christopher hesitated, clearly seeking a way to gracefully refuse. He looked so much like a deer in the headlights that Rebecca felt a moment’s compassion for him. All the poor man wanted was to be left alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hope Mary Martha’s not bothering you,” she said.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mom!”")]), _vm._v(" Mary Martha exclaimed indignantly. “I’m not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bothering")]), _vm._v(" him!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not at all,” Christopher affirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay.” Rebecca paused. “Well, you let me know if you change your mind about that coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will,” he assured her, with obvious relief, and turned back to his weeding. Rebecca watched for a moment more, then shrugged and closed the window. There were worse things, after all, than a reticent tenant bent on cleaning up the yard. The last guy who’d lived downstairs had played the drums.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dear Brother James,")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It is common courtesy to thank you for your most recent letter, yet I continue to feel you are misguided in your zeal for communication. You seem gripped by an ambition to save my soul. But I assure you such a hope is in vain. The word")]), _vm._v(" monk "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("comes from the Late Greek")]), _vm._v(" monakhos, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“solitary,” and ultimately from")]), _vm._v(" monos: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“alone.” The first monks were men who went into the Egyptian desert to be alone with God. That dangerous solitude is still at the heart of the monastic vocation. (If I can still speak of a monastic vocation, in my own case. Perhaps I am called to a simpler ruin.) All monastery walls, in principle at least, are the borders of a wasteland, and every monk is a man who lives alone. But what we learn in the monastery, eventually, is that the walls are false, a convenience and a lie. There are no borders to the wasteland. The desert is everywhere; it is that which we call the world. And every man is a man alone.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You fear that in leaving Our Lady of Bethany I have somehow pronounced the life I led there—and thus, by implication, the life")]), _vm._v(" you ")]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("lead there—“irrelevant.” You may find my real sense of the issue more disheartening still: I believe it is a mistake even to ask whether the monastic vocation is relevant. It is no more relevant now than it ever was. The truths of the desert are useless truths. A man alone is a useless thing. And it is a useless thing to speak of God.")])])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It is to such lucid uselessness, I still believe, that I am called. But I may well be perverse. We expect God’s presence to be thunderous, spectacular, monumental; but it is our need that is so large. The real presence slips past our demands for spectacle. It slips past our despair. Not just like a child—sometimes it")]), _vm._v(" is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a child. She walks down the blistered steps to where you kneel and says the simplest things. She is entertained by butterflies. She has opinions about unicorns. She does not seem to care that you are ruined and lost. She does not even seem to notice. Find an earthworm in the neglected loam and she will make you feel for a moment that your life has not been wasted. Name a flower and she will make you feel that you have begun to learn to speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("May your own path lead you, dear Brother James, to whatever degree of relevance you desire.")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yours in Christ,")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael Christopher")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("M")])]), _vm._v("ary Martha came trooping in from the backyard just before noon, pink with sun and a little manic. Mike had had to go to work, she announced. He had gotten a job at McDonald’s. This sounded suspiciously like a six-year-old’s fantasy career to Rebecca, or some kind of mis")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("communication—perhaps Christopher had said McDonnell Douglas, or Macintosh, though what an ex-monk might do at either corporation was beyond her. Still, whatever the factual basis of the rumor, it was good to hear that Christopher had found work.")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hustled Mary Martha into the bathtub and out and had her daughter dressed in jeans and sneakers, with her overnight bag packed with a change of clothes and a traveling contingent of unicorns, by 12:30. Rory didn’t show up until just after 1:00, which was not bad, all things considered. Any appointment was an approximation with her ex.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rory bounced in wearing his wet-suit bottoms and a T-shirt that said "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maui Legends,")]), _vm._v(" trailing sand and smelling of marijuana smoke. He had promised Rebecca after endless battles not to get stoned in front of Mary Martha, and according to his strict constructionist reading he abided by the rule, taking his last hit in his car out front before he came in to pick her up. Rebecca hesitated, wondering as always whether to call him on it. The spirit of the law, she felt, was not to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("be")]), _vm._v(" stoned in front of Mary Martha. But it was a hard thing to fight about with their daughter right there and Rory already toked into imperturbability and acting hipper-than-thou. And she just didn’t have the energy to fight it anymore. Maybe that was what your life became, eventually: a series of stalemates you had fought to the point of exhaustion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Flying high, are we?” she said impotently, hating herself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("“Always,” Rory smiled. He met her eye and almost, but not quite, winked, riding the edge of her irritation like a tricky wave before he ducked away to give Mary Martha a hug. He didn’t quite have rock-star good looks, though he acted like he did and usually pulled it off. He was actually a little funny looking in a lopsided Irish way, with an off-center grin and a face like an amiable fisherman’s, bright blue eyes, and an air of ")]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("perpetual, puppylike alertness. He had a tough, square body, thick through the chest and bandy-legged. He’d kept his waistline, burning endless calories in the cold Pacific, but there were distinct threads of silver in his long, dishwater-blond hair, which Rory had worn pulled back into the same monotonous strand for twenty years. He was going to do the gray ponytail thing. He was going to play forever.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mike said I could plant some flowers,” Mary Martha told him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wow, flowers, wonderful!” Rory exclaimed, readily enough. “Who’s Mike?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Our new tenant downstairs,” Rebecca said. “I finally got the in-law apartment in shape.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("monk,")]), _vm._v("” Mary Martha announced.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wow, a monk, no kidding. Does he wear a robe and sandals?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She giggled. “No, silly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Does he keep you up all night with his incessant chanting?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s very nice,” Rebecca said, before things got out of hand. “Very ordinary. Just a guy. Makes his own coffee, keeps to himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I suppose it was inevitable you would end up with an ascetic, on the rebound from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not on the rebound from you, Rory. And all I did was rent an apartment to the man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course,” he said, maddeningly. He bent to Mary Martha again. “Are you ready to go, Number One?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s an eight-foot break down by Half Moon Bay, I hear. Are you up for that?”")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Make it so, then. Warp speed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aye, aye, Captain!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s already had her lunch,” Rebecca said. “There’s a snack in the bag, for later in the afternoon. And some sunscreen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” Rory said, clearly humoring her. He picked up Mary Martha’s bag and took her hand, and they walked together toward the front door. Rebecca followed and watched them down the front steps to Rory’s ancient Rambler station wagon, with his long board in the rack on top and his boogie board in the back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seeing her daughter off with Rory, she always had the sense of sending her out to sea in a paper boat. Rory would bring Mary Martha back on Sunday evening, and she would have had nothing to eat in the meantime but 7-Eleven food, plastic-wrapped tacos, Fritos, and Mountain Dew. Her nails would be painted some weird shade of industrial green by Rory’s current girlfriend. She would be sunburned if the weather had been good and chilled to the bone if the fog had come in. She would have done nothing in his apartment in the Haight but watch "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek")]), _vm._v(" reruns. Rebecca knew these things not just from debriefing Mary Martha—who found nothing particularly wrong with the time she spent with her father—but because she had lived this way herself with Rory for years. They had cherished a few artistic aspirations and a vague, drug-fueled sense of mission. But the dreams they’d had had come to nothing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("It wasn’t that Rory was stupid, though he liked to pretend he was. He was widely read in literature and philosophy; he was at home with Hesse and Camus and could ramble on about Buddhism and the Tao. He was perhaps too at home ")]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("with Alan Watts. But essentially Rory lived for that clean moment when the wave lifted him free of everything but the Zen of balance. He called that freedom, and he had built his life around it. It seemed like enough to him, and it had seemed like enough to Rebecca for what, in retrospect, was an embarrassingly long time. If she hadn’t had Mary Martha, she thought, she might still have been sitting there on the tailgate of the woody, doing her futile little watercolors and drinking Budweiser out of cans, oohing and aahing every time someone found a wave to work offshore. She might have been painting her nails industrial green and living in the eternal moment from joint to joint. Waiting for Rory to grow up.")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca realized that she was fingering the guitar pick that hung over her heart. She let go of it self-consciously, irritated with herself. She was really going to have to put the damned thing in a drawer someday. At the curb, Mary Martha waved from the passenger seat as Rory turned the key and the balky ignition labored.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Seat belt!” Rebecca hollered. Mary Martha nodded and obeyed. The Rambler’s engine caught at last. Rory put the car in gear and gave Rebecca a jaunty, slightly condescending wave, which Mary Martha echoed. Watching them drive off together, side by side, Rebecca had to admit to herself that the two were unmistakably father and daughter. Mary Martha had Rory’s eyes, his coloring, and his grin; she had his nose and something of his bandit leprechaun’s twinkle. But that was something Rebecca usually tried not to notice too much, because really, if you dwelled on it, it could break your heart.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("he prospect of a free afternoon was almost daunting. She’d brought her current project home from the office on Friday, intending to dutifully ruin her weekend with it, but in the unaccustomed silence that settled over the house after Mary Martha’s departure, Rebecca could not bring herself to plunge right into the work. Maybe it was seeing Rory, still flaunting his freedom from the trappings of responsibility; she knew how appalled he would be by her spending a Saturday afternoon yoked to her computer, in the service of a paycheck. In a way, she even appreciated his sturdy sense of spontaneity. Say what you might about her ex-husband, he had always given her the courage to play. She wondered sometimes now whether she had lost that courage without him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the far side of the kitchen—beyond the counter she kept meaning to clear off, the one cluttered with a broken toaster, a 1992 Makaha Surfing Festival Souvenir Cutting Board that Rory had given her, which could not be used because the paint flaked off, and a misshapen Play-Doh pot full of wooden spoons, made by Mary Martha at the age of three—the door to the garage was ajar. Mary Martha was learning to take out the trash, but she had not yet mastered doorknobs and locks. Rebecca moved to close the door, then on a second thought opened it and descended the stairs into the garage. Sometimes Mary Martha put the garbage in the wrong can too. Michael Christopher did not look to be a man who would generate much trash, but Rebecca liked to keep things as separate as she could.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("In the dim light, the garage was crowded with debris, useless utensils and objects of dubious sentimental value, broken bicycles and broken rakes, the paddles to a lost canoe, and boxes whose contents had long since passed into obscurity. One of Rory’s old surfboards lay askew against the near wall, mottled with dings he had never bothered to repair. The square space ")]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("that Rebecca had cleared in the back corner for Michael Christopher to use for storage was the only empty spot in the whole garage. The previous tenant had filled that space almost to the ceiling with amplifiers, bongo drums, and boxes of old LPs, but Christopher had put nothing there and the austere expanse of bare concrete seemed vaguely like a reproach.")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mary Martha had managed to drop the garbage into the right can but had failed to replace the lid. Rebecca secured the plastic top and started toward the stairs but paused near the middle of the garage, where an old easel with a sheet thrown over it jutted from the jumble of shadows. In the poor light it looked vaguely like a tombstone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("The dream had been that they would live off their art: she would paint her Turneresque seascapes and Caspar David Friedrich skies and sell them to tourists, while Rory surfed professionally; they would wander the earth together, skipping lightly along the border between the ocean and the sand, stopping at the occasional flea market or boardwalk show to unload a canvas or two and hitting all the big surfing events. The plan had even worked for a while. She’d acquired a glib knack for sunsets and sailboats, and her work had sold well, while Rory in his prime could count on enough prize money to keep them in beer and sandwiches and gasoline. But in the end, the hustling had worn them down. As Rebecca’s work had grown subtler and more structural, less Turner and more Cézanne, she’d found herself resisting and finally abandoning those Jonathan Livingston seagulls scything against an azure sky and the neat white sails beneath the Golden Gate, which the tourists loved so much; while Rory in the long run had had little patience for the discipline of competition. And so there had been restaurant work, and janitorial work, and some dealing on ")]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("Rory’s part. There had been brushes with landlords and the law. By the time Rebecca had gotten pregnant with Mary Martha, the dream of living free, brave artists’ lives had been muddied by the simpler scramble for survival, and with her daughter’s birth the easel had been relegated permanently to the garage.")])]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The string to the overhead bulb had frayed away years before. Rebecca dragged a three-legged chair beneath the light, clambered onto it, and reached precariously to click the light on. Safely back on the ground, she slipped the sheet off the easel, exposing the work in progress there. In the watery sixty-watt light, a sea of dream-pure aquamarine threw a perfect wave against a forested shore. Beyond the breakers, a figure showed—not quite a surfer, not quite a merman—a figure lost in the glare at the edge of myth. On the shore, a woman dwarfed by the sea and trees and sky walked alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("More canvases were stacked nearby and still more strewn haphazardly through the garage’s disorder like the half-burned tinder of a fire kicked apart in breaking camp: paintings barely begun or nearly finished, paintings botched and abandoned or painted over, with the occasional near success thrown in to keep deluded hope alive. All cold and gray with time now, the dead ash of her once-bright art.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca found the sunlight in the painting on the easel holding her eye, even in the bad light; she’d caught something there, a knifing fire, slicing the sky and sea. She was half tempted to dig her palette and oils out of the detritus and see what she could make of that brilliant hint. But that way lay only frustration, she knew. She didn’t have time to paint the bathroom these days, much less finesse some ephemeral effect she’d glimpsed on water years ago. She threw the sheet back over the canvas and turned toward the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])]), _vm._v("n the end, as she had known she would, she spent the afternoon on the computer, trying to make a lightbulb sing and dance. The graphics company she worked for had started landing corporate accounts in recent years, including this PR bit for PG&E. Relatively huge amounts of money were at stake, and suddenly deadlines mattered. There was even talk at work of “changing the dress code.” There had never been a dress code before. For years, the company’s founder, Jeff Burgess, had prided himself on running a hip little operation staffed by artists who did impeccable idealistic things like pro bono work for the women’s shelter and witty homages to the Grateful Dead. Utopian Images had been aiming for a world of beauty and a three-day workweek. But Jeff had two kids and a house on Potrero Hill now, and everybody was working weekends.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The lightbulb was supposed to be some kind of animated hybrid of Woody Guthrie and Fred Astaire, “but hip,” according to the brief Rebecca had been given by Jeff. Some genius at PG&E was shooting for the moon. Utopian Images drew a particular sort of corporate type, people who no longer took LSD but wanted to remember that they had. Apparently a lightbulb singing “This Land Is Your Land” and gliding from the redwood forest to the Gulf Stream waters in a tuxedo at the behest of a monopoly kept the flame of vision burning.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("The problem now was technical. The new animation program they were using was the latest thing, and Rebecca hadn’t figured it out yet. She struggled with it into the evening, adrift in that special, almost psychotic frustration that came with computers. She couldn’t figure out how to turn off the sound either, and the chipmunk-voiced version of “This Land Is Your Land” played every time she tried to run an image sequence. She tried calling Jeff, to beg for some kind of tech support, but ")]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("he wasn’t home or wasn’t answering. No doubt he was out somewhere enjoying his life.")])]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At last she gave up, saved everything, including the spiteful little sequence of the lightbulb guy tumbling off a Humpty-Dumpty–like wall, and took a long bath to try to get back in her body. The sun was just going down when she got out of the tub. Rebecca put on some old sweatpants and a thermal underwear shirt, feeling the luxuriousness of sloppy comfort. She poured herself a glass of red wine, took her cigarettes out to the back porch, and sat down on the top step. She had taken only one smoke break all afternoon, smoking two cigarettes then, so she figured she had three to burn. She lit the first and breathed in, still trying to slow down, still trying to get that chipmunk song out of her head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sun across the rooftops was half a hand above the Pacific, bright and brisk in a colorless sky. There wasn’t a scrap of fog or a cloud to be seen; it had been one of those rare August days when San Francisco seemed to have a summer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Below her and to her right, the door from the garage opened tentatively, and Michael Christopher stuck his head out. Even in the shadow, his stoop was distinctive, the shoulders rounded as if against rain, the curve of his skull still barely blurred with his new secular hair. He was wearing something that looked like prison garb or a clown suit. Rebecca realized that it was a McDonald’s uniform. So Mary Martha had gotten it right after all. She hardly knew whether to be amused or sympathetic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I couldn’t help but smell the smoke,” Christopher said apologetically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, I’m sorry! Is it disturbing you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("He hesitated, apparently diffident, and Rebecca felt a stir of panic at the thought of losing her back porch reveries. But ")]), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_vm._v("Christopher said, “Actually, I was hoping you had one to spare.”")])]), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rebecca laughed in relief. It was reassuring somehow to know that he had a vice compelling enough to overcome his moroseness. Christopher took her laughter for assent and started up the stairs. She picked up her whole operation, seashell, cigarettes, lighter, and wine, and met him halfway, instinctively protecting her haven at the top of the stairs. They settled on the fourth step from the bottom. She offered him the pack, banging one cigarette expertly into prominence, and Christopher slipped the Marlboro free and lit it. In the lighter’s flare she noticed again how young he looked without his beard. Or maybe it was just the McDonald’s uniform that made him seem like a teenager now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wouldn’t have thought a monk would smoke,” Rebecca ventured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’d be amazed. Some of the old-timers were like chimneys. The younger ones, not so much.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her own cigarette was down to the filter. Rebecca stubbed it into the abalone shell and took another. Christopher reached for the lighter, gallantly enough, and she bent over the flame.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wanted to thank you for taking a shot at the yard,” she said. “And for putting up with Mary Martha all morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hardly ‘putting up with.’ She’s wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t be afraid to draw your lines with her. She needs that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t we all,” he murmured. She glanced at him dubiously, not quite sure what he meant. Christopher noticed and smiled. “Having just spent almost twenty years so very much inside the lines myself, is all I was getting at. I’ve been feeling my linelessness, a bit.”")])]), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“God, twenty years. I’ve never done anything in my life for twenty years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was no marvel of stability. Sometimes it seems to me that all I really did was keep my costume on and attend the events. But it does set up a certain tension.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And now you’ve got a different costume.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled ruefully. She had been speaking metaphorically; she hadn’t meant the McDonald’s uniform, but there was no way around it once the words were out of her mouth. Rebecca laughed. “Oops. Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s okay. I was lucky to find work at all. There’s a big hole in my résumé.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She met his eyes briefly. In the twilight, he was, ever so slightly, amused by his own plight. She found herself liking him better for it: this forty-something man reduced to flipping hamburgers for minimum wage, keeping his sense of humor. There was a kind of nobility in it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" you leave?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Christopher shrugged and attended to his cigarette. “It’s a long story.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, so you said.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A silence followed. Christopher smoked his cigarette down to the filter and lit another off the butt. Rebecca sat quietly, feeling helpless as the pause grew awkward, and then painful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You said you had a fight with your abbot,” she offered at last, tossing it into the silence like a life ring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My abbot was a jerk,” Christopher conceded. “But that had nothing to do with it, ultimately.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blanket denial rang a little false, the first such note she’d heard from him. But who was she to judge? She’d built her life on issues half resolved at best. Rebecca hesitated, then offered, “I suppose it’s a little like a marriage breaking up.”")])]), _c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I suppose it is,” he said glumly. “Apparently, I’ve got irreconcilable differences with God.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She thought that this might be a joke but didn’t dare smile. They sat in silence again for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“After I broke up with Rory I couldn’t stop hating either him or myself, for years,” Rebecca said at last. “Like someone has to fail, for love to fail. Even now…” She shook her head. “Jesus, deep waters. Don’t get me started. I see your point. I promise, I won’t ask again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, I—I like it, that you asked.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_vm._v("He meant it, perhaps too intensely. It seemed dangerously intimate. Certainly it was more than she had bargained for, making small talk with the new tenant. Rebecca realized that Christopher reminded her of a boy she had known in high school, Fulmar Donaldson. Fulmar had been a gloomy, taciturn presence at the back of her English class during her junior year. He was a skittish, prematurely philosophical kid suffering under the burden of the ordinary, who always ate lunch alone at the top of the bleachers on the far side of the football field, immersed in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Fountainhead")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Franny and Zooey.")]), _vm._v(" One day after class, without any previous indication of interest, he had edged up to her in the hallway and asked her to a school dance. Rebecca, startled, had accepted, out of some mix of compassion and curiosity, letting herself in for a long, strained night. Fulmar danced like someone surprised by his own body. His conversation had been intermittent at best, veering from an overheated silence to Kafka, whom he apparently felt to be relevant to the scene in the gym. During the slow dance, to Cat Stevens’s “Wild World,” Rebecca had felt him trembling. It was like holding a wounded animal. The colored lights flashed on the gym walls, the music blared, the other couples danced around them in varying degrees of hap")]), _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_vm._v("piness and self-consciousness, and Fulmar simply floundered, beyond self-consciousness, nearly paralyzed. But he kept trying, nobly, to be her date, according to his vague understanding of the role. It had been a kind of heroism on his part, Rebecca had realized, to ask her to the dance at all: a sweet futility, a kamikaze charge into a realm in which he was not really fit to function, tilting at some windmill hope of relationship.")])]), _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally, to end his suffering, she had taken matters into her own hands. She bought them two Cokes from the machine in the gym lobby and led him outside, around the dark track and up the steps of the dark bleachers to the top row. Beneath the stars, away from the music and the crowd, on his home turf, as it were, Fulmar had calmed down. They talked about movies and books and integrity. Fulmar had been very big on integrity. Clearly, he felt his own to be embattled. He thought like he danced, flailing rather more than was necessary and not accomplishing much. But he was genuine, and passionate. He had also been big on truth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_vm._v("He had driven her home in his father’s Pontiac and walked her to the front door. Before the pall of expectations could stymie him again, Rebecca had taken his face in her two hands and kissed him. Fulmar had been startled, but not unhappily so. She could still remember the way he had become simple for a moment, the way his lips had softened. Any kiss was an adventure, at that point in her life, and Rebecca’s own heart had been pounding in her chest. She lay awake half the night, wondering what it meant. It was going to be hard to explain to her friends what she saw in Fulmar Donaldson. It would be a kind of martyrdom. But on Monday at school, Fulmar wouldn’t meet her eyes. She had known, even then, that he was just afraid. But knowing that changed nothing. He had ")]), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_vm._v("gone back inside the cloud of himself. And she had found that she was relieved.")])]), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Christopher seemed to sense her misgiving and instantly drew back. They sat for a moment in silence, their faces turned to the last glow of the vanished sun. At the base of the stairs, the ragged patch of dirt that Christopher had reclaimed that morning from the weeds was deep in shadow. It still looked oddly like damage, Rebecca thought. It looked, somehow, like a mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She started to reach for her wine, then stopped herself, feeling that it would be rude to drink in front of him without offering him a glass, but not wanting to offer him a glass, not wanting to go any deeper, not wanting the responsibility of that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Christopher, abruptly, stubbed his half-smoked cigarette out and stood up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I should go,” he said, seeming genuinely pained, and fled before she could object. Rebecca watched him disappear through the garage door and thought that perhaps she had gotten spoiled, dating men like Bob, who couldn’t take a hint. There was something very appealing in Christopher’s hair-trigger sensitivity to thoughts she hadn’t even voiced. But she felt no urge to run after him and apologize for what was after all a relatively subliminal rudeness. All she’d done, really, was draw a little line.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("he fog came in overnight. Rebecca spent the morning in bed with the Sunday paper and a mug of coffee, warm and contented, savoring the contrast with the ")]), _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_vm._v("cool gloom outside. She let the answering machine handle two calls from Bob and three hang-ups, probably also Bob. He sounded peevish, perhaps justifiably so. But she had no desire to talk to him. The marriage proposal had hardened something in her, Rebecca realized. She had scared herself, letting it go that far with Bob. What she really needed, clearly, was a deeper self-sufficiency. Not picking up the phone for his plaintive ramblings seemed more cruel than self-sufficient, but it was a start.")])]), _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had a late breakfast and got to work on the computer, feeling noble and committed to a calm professionalism when she turned it on but squandering the long morning’s measure of serenity almost instantly. The program was as balky, convoluted, and maddening as ever, and the job was idiotic. When the machine crashed for the second time, taking two hours’ futile labor with it, Rebecca simply turned it off and fled to the back steps, where she smoked three of the day’s five cigarettes one after the other, feeling herself careening irresponsibly toward lung cancer, toward leaving Mary Martha motherless.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She lit a fourth cigarette off the butt of the third. At the bottom of the stairs, the hacked-out corner of dirt that Christopher had weeded the day before seemed naively optimistic beneath the low gray sky. He had left his trowel beside the back door, Rebecca noted, as if to have it handy to his return, but he had not been out today. Probably she had scared him off and forever discouraged whatever feeble energy for improvement he had had.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_vm._v("On an impulse, she descended the stairs. Avoiding the blank stare of the in-law apartment’s window, she picked up the trowel and went out into the yard. She put her cigarette between her lips and knelt at the edge of the fresh dirt. Feeling a little ridiculous, she worked a weed loose and tossed it onto ")]), _c('a', {
    attrs: {
      "id": "page58"
    }
  }, [_vm._v("the pile that Christopher had left nearby. The effect on the sea of weeds was negligible. The small yard seemed vast from this perspective. Rebecca stubbed the cigarette out and attacked another weed.")])]), _c('a', {
    attrs: {
      "id": "page58"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She worked for almost two hours without feeling that she had made much progress, breaking two nails in the process, but she went inside to shower feeling cheerful. Perhaps she was a peasant at heart, Rebecca thought. A simple soul, craving simple labor: see weed, pull weed. There had been no sign of Christopher, but it gave her some pleasure to know that he would discover the little beachhead of cleared ground mysteriously enlarged, as if by elves. She felt absurdly proud of that few square feet of churned new dirt.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Mary Martha came home that night trailing sand from every pocket, ensconced in the combination of elation and smug reserve that she often had when Rory dropped her off. Rebecca suspected that Rory was allowing Mary Martha some slightly outrageous liberty and having her promise not to tell. It was infuriating, but there was nothing Rebecca could see to do about it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gave Mary Martha her bath and made her dinner, which she just picked at. Rory, invariably, won the Sunday food battle. There was no competing with microwave burritos and nachos. Afterward, they curled up in front of the TV and watched "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek: Voyager.")]), _vm._v(" The show seemed much longer than an hour, but Rebecca had found that if she could just endure the space adventures it was a great way to reestablish some rapport.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Daddy has seen flying saucers,” Martha Mary confided at the first commercial. “He sees them over the ocean all the time.”")])]), _c('a', {
    attrs: {
      "id": "page59"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How about that,” Rebecca said, which probably wasn’t the best way to deal with such a complex claim. But it seemed preferable to her gut response, which was that Mary Martha’s father was a drug-addled flake. And Rebecca knew she was vulnerable on this ground of belief. Rory, at least, had faith in UFOs. What sort of spiritual sustenance was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" offering her daughter? What cosmic certainties? The tepid Catholicism of her own childhood was more like a lingering headache than a source of strength. She had picked for years at the smorgasbord of Californian spirituality and come away hungry. She felt her frustrated need for ardor as a burden and her longing for depth as a kind of dull pain. Sometimes, to be sure, smoking the last cigarette of the day, looking up at the stars, she would feel for a moment that life was bearable. But that wasn’t much to offer a child’s soul: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Someday, sweetheart, with enough wine and nicotine, you too will be glad just to have survived another day. You may even, briefly, be content.")]), _vm._v(" It wasn’t enough for anyone, really. But it was what she had.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page59"
    }
  }, [_vm._v("The gallant crew of the starship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Voyager")]), _vm._v(" lived to fight another day. The credits rolled and the teasers came on: next week’s battle would be tougher still. Rebecca put Mary Martha to bed and read to her for a while from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The House at Pooh Corner.")]), _vm._v(" Her daughter settled in and listened raptly, as she always did, with no indication that further intergalactic intrigue was required, and something in Rebecca began to relax. Every other Sunday, Mary Martha came home half a stranger. Rebecca could feel the strain of having to compete with the glamorous sea and a sky full of aliens and the menu at the 7-Eleven for her daughter’s trust. But there always came that moment when the real world of her intimacy with Mary Martha reasserted itself, when the warmth and the familiar closeness overcame the jangle. She didn’t have to sing and ")]), _c('a', {
    attrs: {
      "id": "page60"
    }
  }, [_vm._v("dance, dazzle with special effects, or communicate with distant stars. All she had to do was keep the home fire burning and wait it out. All she had to do was love.")])]), _c('a', {
    attrs: {
      "id": "page60"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her daughter’s eyes closed, and her breathing turned regular and slow. Rebecca sat quietly by the bedside, in no hurry to go anywhere. No, she would not give in to that jangling world without a fight. She had something to offer too. She had the best thing.")])])]), _c('a', {
    attrs: {
      "id": "page60"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page60"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122c46b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008-chapter02.vue
// module id = 78
// module chunks = 0